import { render, staticRenderFns } from "./step-bbva.vue?vue&type=template&id=60acdccf&scoped=true"
import script from "./step-bbva.vue?vue&type=script&lang=ts&setup=true"
export * from "./step-bbva.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./step-bbva.vue?vue&type=style&index=0&id=60acdccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acdccf",
  null
  
)

export default component.exports